export class AiProcessesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAiProcesses(params) {
    return this.#http.get('/ai-processes', { params, paramsSerializer: { indexes: null } });
  }

  async getAiProcessById(id) {
    return this.#http.get(`/ai-processes/${id}`);
  }

  async createAiProcess(body) {
    return this.#http.post('/ai-processes', body);
  }

  async updateAiProcess({ id, ...body }) {
    return this.#http.put(`/ai-processes/${id}`, body);
  }

  async deleteAiProcess(id) {
    return this.#http.delete(`/ai-processes/${id}`);
  }

  async getAiProcessFormSchema(aiProcessId) {
    return this.#http.get(`/ai-processes/${aiProcessId}/form-schema`);
  }

  async updateAiProcessFormSchema(aiProcessId, body) {
    return this.#http.put(`/ai-processes/${aiProcessId}/form-schema`, body);
  }

  async deleteAiProcessFormSchema(aiProcessId) {
    return this.#http.delete(`/ai-processes/${aiProcessId}/form-schema`);
  }

  async getAiProcessTemplates(params) {
    return this.#http.get('/ai-processes/templates', { params });
  }

  async enableAiProcessTemplate(id) {
    return this.#http.post(`/ai-processes/${id}/enable`);
  }

  async disableAiProcessTemplate(id) {
    return this.#http.post(`/ai-processes/${id}/disable`);
  }

  async cloneAiProcessTemplate(id) {
    return this.#http.post(`/ai-processes/${id}/clone`);
  }
}
